import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserModel } from "app/_models/user-model";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CrudInvProjectService {
  private _refreshrequired = new Subject<void>();
  _baseUrl = environment.baseUrl;
  currentUser: UserModel;

  constructor(private http: HttpClient) {}

  get Refreshrequired() {
    return this._refreshrequired;
  }

  getInvProjectDetailById(id: number) {
    return this.http.get<any>(
      `${this._baseUrl + "Common/GetInvProjectDetailById?invProjectId=" + id}`
    );
  }

  getInvProjects(yesNoAll: number) {
    return this.http.get<any>(
      `${this._baseUrl + "Common/GetInvProjects?yesNoAll=" + yesNoAll}`
    );
  }

  getPagedInvProjects(model:any): Observable<any>{
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(`${this._baseUrl}Common/GetInvProjects`, model, options);
  }

  saveInvProject(projectName: string, description: string): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let model = {
      projectName: projectName,
      description: description,
      createdBy: this.currentUser.userId,
    };
    return this.http
      .post<any>(`${this._baseUrl}Common/SaveInvProject/`, model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  updateInvProject(
    invProjectId: number,
    projectName: string,
    description: string
  ): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let model = {
      invProjectId: invProjectId,
      projectName: projectName,
      description: description,
      updatedBy: this.currentUser.userId,
    };
    return this.http
      .post<any>(`${this._baseUrl}Common/UpdateInvProject/`, model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  deleteInvProject(invProjectId: number): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let model = { id: invProjectId, updatedBy: this.currentUser.userId };
    return this.http
      .post<any>(`${this._baseUrl}Common/DeleteInvProject/`, model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }
}
